import React from 'react';
import {Button, Tag, Typography} from 'antd';
import {HomeOutlined} from '@ant-design/icons';
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import RenderIf from "@/components/render-if";

const {Text, Title} = Typography;


function PopupMapAdminClassroom({item}) {
    return (
        <div className={'rtl peydaFont'}>
            <div className="text-xl font-bold text-center mb-2">{item?.title}</div>
            <div className="flex flex-wrap gap-2 justify-end">

                <div className={'w-full'}>
                    <Tag color={'geekblue'}>#{item?.id}</Tag>
                    {/*<Tag color={item?.status === 'enable' ? 'success' : 'default'}>*/}
                    {/*    {item?.status === 'enable' ? 'فعال' : 'غیرفعال'}*/}
                    {/*</Tag>*/}
                </div>
                <div>
                    <RenderIf condition={item?.street || item?.address}>
                        <div className={'text-right'}>
                            <HomeOutlined className={'mx-1 peydaFont'}/>
                            {item?.street} {' '}
                            {item?.address}
                        </div>
                    </RenderIf>

                </div>
                <div>
                    <Link to={sprintf(URLS.admin.classroom.edit, {id: item?.id})}>
                        <Button size={'small'} variant={'solid'} color={'geekblue'}>ویرایش</Button>
                    </Link>
                </div>
            </div>


        </div>
    );

}

export default PopupMapAdminClassroom;